// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3QyZg","upload":"Small_upload__3L6ks","imageWrap":"Small_imageWrap__3ThNI","removeBtn":"Small_removeBtn__1x8CK"};